import { SolutionType } from './types';

interface SolutionDescriptor {
  value: SolutionType;
  label: string;
  description: string;
}

export const SOLUTIONS: SolutionDescriptor[] = [
  {
    value: 'pc_v2',
    label: 'Planogram Compliance v2',
    description: 'New PR-based out detection. Detects empties and faceovers. Runs the model pipeline.',
  },
  {
    value: 'legacy_match_oos',
    label: 'Core Model (match + OOS)',
    description:
      'Imports the Core Model’s existing match+OOS predictions from SQL — no model run. ' +
      'Creates two runs (low scored as in-stock and as out) for side-by-side comparison.',
  },
];

export const DEFAULT_SOLUTION: SolutionType = 'pc_v2';
